import { graphql } from "react-relay";
import { TailoredDefragSummaryEventMoved } from "../tailored-defrag-summary-event-moved";

export const fragments = {
  eventsMoved: graphql`
    fragment TailoredDefragSummaryEventsMovedList_eventsMoved on DefragExplainedMove
    @relay(plural: true) {
      ...TailoredDefragSummaryEventMoved_eventMoved
    }
  `,
  rooms: graphql`
    fragment TailoredDefragSummaryEventsMovedList_rooms on RoomList {
      ...TailoredDefragSummaryEventMoved_rooms
    }
  `,
};
